import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '@card-software/library';
import { QualityDefect } from '../../models/inventory/quality-defects';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QualityDefectProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/quality-defect-type';

  getQualitiesDefects(): Observable<ApiResponse<QualityDefect[]>> {
    return this.httpClient.get<ApiResponse<QualityDefect[]>>(`${this.baseUrl}/all`);
  }
}
